(function webpackUniversalModuleDefinition(root, factory) {
	//test comment...
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"));
	//test comment...
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	//test comment...
	else if(typeof exports === 'object')
		exports["trowe-controls"] = factory(require("react"), require("prop-types"), require("classnames"));
	//test comment...
	else
		root["trowe-controls"] = factory(root[undefined], root[undefined], root[undefined]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 